module.exports = __webpack_public_path__ + "img/gift_icon.6da7d122.png";